export default {"src":"/_next/static/media/Project.40e4908a.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};